export default {
  MODULE_NAME: 'app',
  PRINT_MODE_NONE: 0,
  PRINT_MODE_PROFILE: 1,
  PRINT_MODE_PROFILE_AND_SOURCES: 2,
  PRINT_MODE_FULL: 3,
  PRINT_MODE_DIRECT: 4,
};
